<script setup lang="ts">
import { onMounted, onBeforeUnmount, watch, computed, unref } from 'vue'
import { componentsBridge, type WiredComponent } from '@gto/gw-store'
import { mapValues } from 'remeda'

const props = defineProps<{
  name: WiredComponent
  props?: Record<string, any>
}>()

const rootId = computed(() => `${props.name}-react-wrapper-${Math.random().toString(36).slice(8)}`)

watch(
  () => props.props,
  newProps => {
    componentsBridge.trigger.updateComponentProps({
      componentName: props.name,
      componentRootId: rootId.value,
      props: mapValues(newProps ?? {}, value => unref(value)),
    })
  },
  { deep: true },
)

onMounted(() => {
  componentsBridge.trigger.mountComponent({
    componentName: props.name,
    componentRootId: rootId.value,
    props: mapValues(props.props ?? {}, value => unref(value)),
  })
})

onBeforeUnmount(() => {
  componentsBridge.trigger.unmountComponent({
    componentRootId: rootId.value,
    componentName: props.name,
  })
})
</script>
<template>
  <div
    :id="rootId"
    style="width: 100%; height: 100%"
  ></div>
</template>
